import Stack from "./Stack";

export default Stack;
